export const APPROVED = "Approved";
export const ACCOUNTING_APPROVED = "approved";
export const ACCOUNTING_CANCELLED = "cancelled";
export const REQUESTED_CHANGES = "Requested Changes";
export const INVOICED = "Invoiced";
